import React, { useState } from "react";
import { LinkIcon } from '../appearence/icons/link_icon';

const CustomSelect = ({managersList, setValidatedUser, validatedUser, inviteUser}) => {
    const [state, setState] = useState({
        defaultSelectText: inviteUser? "Выберите роль":"Выберите менеджера",
        value: '',
        showOptionList: false,
        optionsList: managersList,
    });
    const handleListOpen = () => {
        setState({
            defaultSelectText: inviteUser? "Выберите роль":"Выберите менеджера",
            value: '',
            showOptionList: !state.showOptionList,
            optionsList: managersList,
        });
    };
    const handleOptionClick = (title, value) => {
        setState({
            defaultSelectText: title,
            value,
            showOptionList: false,
            optionsList: managersList,
        });
        if(inviteUser) {
            setValidatedUser(state.optionsList.find(it => it.value === value).value);
        } else {
            setValidatedUser({...validatedUser, managerId: value});
        }
        
    };

    return (
        <div className={`custom-select__container ${inviteUser?'':'modal-select__container'}`}>
            <div
                className="custom-select__text"
                onClick={handleListOpen}
                onChange={handleListOpen}
            >
                {state.defaultSelectText}
                <LinkIcon nameOfClass="custom-select__logo navigation-link" />
            </div>
            {state.showOptionList && (
                <ul className="custom-select__options modal-select__options">
                    {state.optionsList.map(option => {
                        return (
                            <li
                                className="custom-select__option"
                                key={option.id}
                                onClick={() => handleOptionClick(option.name, option.id)}
                            >
                                {option.name}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default CustomSelect;